<article id="canvasComponent" class="d-flex flex-nowrap justify-content-between viewerAsset viewerAssetCanvas">
  <div class="viewerCanvasWrapper" [ngClass]="getWrapperClasses()">
    @if (background) {
      <zbp-drawing
        id="canvasDocument"
        [tool]="selectedTool"
        [background]="background"
        [zoomLevel]="zoomLevel"
        [color]="drawingColor"
        [brushSize]="brushSize"
      [orientation]="getOrientation()"></zbp-drawing>
    }
  </div>
</article>
